import { Link, useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import { clearAuthMe } from "../../store/AuthmeSlice/authmeSlice";
import { clearUser } from "../../store/UserSlice/userSlice";
import { checkHiringDateBiggerThanSixMonthes } from "../../libs/generalFunctions";

import "./navButtonsComp.scss"

function NavButtonsComp() {

  const navigate = useNavigate();

  const location = useLocation();

  const dispatch = useDispatch();

  const authMe = useSelector((state) => state.authme.data);

//====Event handler start here====
  const handleGoBack = ()=>{
    navigate(-1);
  }



//logout function
  const handelLogOut = ()=>{
     // Clear local storage
     dispatch(clearAuthMe())
     dispatch(clearUser());
  
     const serializedState = localStorage.getItem('state');
  
     if (serializedState !== null) {
        localStorage.removeItem('state');
     
      }
         
     
     // Navigate to the login page or another page
     navigate('/login');
    }
 
//====Event handler end here====    

  return (
    <div className='nav_buttons_container'>
    

    {
      (location.pathname !== "/emp") &&
      (
      <Link to={"/emp"} className='nav_buttons_item' dir='rtl'>
        الصفحة الرئيسية
      </Link>
      )
    } 


    {
      (location.pathname !== "/emp/salarypage") &&
      (
      <Link to={"/emp/salarypage"}  className='nav_buttons_item' dir='rtl'>
        الراتب
      </Link>
      )
    }  


    {
      (location.pathname !== "/emp/vacationreq") &&
      (
      <Link to={"/emp/vacationreq"} className='nav_buttons_item' dir='rtl'>
        طلب اجازة
      </Link>
      )
    }  


    {
      ( checkHiringDateBiggerThanSixMonthes(authMe) &&  location.pathname !== "/emp/h_insurance_personal_data" && location.pathname !== "/emp/h_insurance_personal_add_by_emp"
        && location.pathname !== "/emp/h_insurance_personal_update_by_emp"
      ) &&
      (
      <Link to={"/emp/h_insurance_personal_data"}  className='nav_buttons_item' dir='rtl'>
        بيانات الأقارب
      </Link>
      )
    }  


    {
      (location.pathname !== "/emp/eval_emp") &&
      (
      <Link to={"/emp/eval_emp"} className='nav_buttons_item' dir='rtl'>
        التقييم و المتابعة
      </Link>
      )
    }  


   {  
   (location.pathname !== "/emp") ?
   (
     <span className='nav_buttons_item nav_buttons_last_item' dir='rtl'  
     onClick={()=>{ handleGoBack(); }}
    >
      عودة الى الخلف
    </span>
   )
   :
   (
    <span className='nav_buttons_item nav_buttons_last_item' dir='rtl'  
    onClick={()=>{ handelLogOut(); }}
   >
     تسجيل الخروج
   </span> 
   )
}

 

</div>
  )
}

export default NavButtonsComp